<template>
    <div class="update-password-modal">
        <b-modal ref="updatePasswordModal" hide-footer size="md" centered>
            <div class="row g-4">

                <div class="col-12">
                    <p class="fs-18 fw-bold mb-1">Update Password</p>
                    <p class="fs-14 text-muted mb-0">
                        Enter a new password for this customer. This will replace the existing password.
                    </p>
                </div>

                <div class="col-12">
                    <label class="fw-semibold mb-1">New Password</label>
                    <div class="position-relative">
                        <input v-model="form.password" :type="showPassword ? 'text' : 'password'"
                            class="form-control rounded-pill px-4" placeholder="Enter new password"
                            autocomplete="new-password" />
                    </div>
                    <small v-if="errors.password" class="text-danger d-block mt-1">
                        {{ errors.password }}
                    </small>
                </div>

                <div class="col-12">
                    <label class="fw-semibold mb-1">Confirm Password</label>
                    <div class="position-relative">
                        <input v-model="form.confirmPassword" :type="showPassword ? 'text' : 'password'"
                            class="form-control rounded-pill px-4" placeholder="Confirm new password"
                            autocomplete="new-password" />
                    </div>
                    <small v-if="errors.confirmPassword" class="text-danger d-block mt-1">
                        {{ errors.confirmPassword }}
                    </small>
                </div>

                <div class="col-12">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="showPassAdmin" v-model="showPassword" />
                        <label class="form-check-label fw-semibold" for="showPassAdmin">
                            Show password
                        </label>
                    </div>
                </div>

                <div class="col-12">
                    <div class="d-flex justify-content-center">
                        <button type="button" class="btn bg-orange text-white rounded-pill px-4 fw-bold" @click="submit"
                            :disabled="processing">
                            <span v-if="processing"><i class="fas fa-spinner fa-spin"></i></span>
                            <span v-else>Update</span>
                        </button>
                    </div>
                </div>

            </div>
        </b-modal>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "UpdatePasswordModal",
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            processing: false,
            showPassword: false,
            form: {
                password: "",
                confirmPassword: "",
            },
            errors: {
                password: "",
                confirmPassword: "",
            },
        };
    },
    methods: {
        openModal() {
            this.resetForm();
            this.$refs.updatePasswordModal.show();
        },
        closeModal() {
            this.$refs.updatePasswordModal.hide();
        },
        resetForm() {
            this.form.password = "";
            this.form.confirmPassword = "";
            this.errors.password = "";
            this.errors.confirmPassword = "";
            this.showPassword = false;
            this.processing = false;
        },
        validate() {
            this.errors.password = "";
            this.errors.confirmPassword = "";

            if (!this.form.password) {
                this.errors.password = "New Password is required";
            } else if (this.form.password.length < 8) {
                this.errors.password = "Password must be at least 8 characters";
            }

            if (!this.form.confirmPassword) {
                this.errors.confirmPassword = "Confirm Password is required";
            } else if (this.form.confirmPassword !== this.form.password) {
                this.errors.confirmPassword = "Password and Confirm Password must match";
            }

            return !this.errors.password && !this.errors.confirmPassword;
        },
        async submit() {
            if (!this.user?.id) return;

            const ok = this.validate();
            if (!ok) return;

            try {
                this.processing = true;

                await this.$axios.post("/user/update-password-by-admin", {
                    id: this.user.id,
                    password: this.form.password,
                    confirmPassword: this.form.confirmPassword,
                });

                Swal.fire({
                    icon: "success",
                    title: "Updated",
                    text: "Password updated successfully",
                    timer: 1400,
                    showConfirmButton: false,
                });

                this.$emit("password-updated");
                this.closeModal();
            } catch (error) {
                const msg =
                    error?.response?.data?.message ||
                    error?.response?.data?.errors?.password?.[0] ||
                    error?.response?.data?.errors?.confirmPassword?.[0] ||
                    "Unable to update password";

                Swal.fire("Error", msg, "error");
            } finally {
                this.processing = false;
            }
        },
    },
};
</script>

<style scoped></style>
